import React from 'react';
import './PageLayout.css';
import Footer from '../components/Footer';

function Tips() {
  return (
    <div className="page-layout">
      <header className="page-header">
        <a href="/" className="page-back-link">← Back to Don't Wordle</a>
      </header>
      <main className="page-content">
        <h1>Tips &amp; strategy</h1>
        <div className="page-body">
          <p>
            Don’t Wordle is about keeping valid words in play without ever submitting the hidden answer. Here are strategies players use in practice and some general notes on the game.
          </p>

          <h2>Basic strategy</h2>
          <p>
            It often pays to use words with <strong>repeated letters</strong> early. Doubling up a letter uses fewer distinct letters in that guess, so you “save” more letters for later rows when you may need flexibility.
          </p>
          <p>
            It also tends to help to spend <strong>rarer letters</strong> sooner. Unusual letters are harder to work into guesses once greens and yellows lock you into a pattern—getting them out of the way can make later words easier to build.
          </p>

          <h2>Common starting words</h2>
          <p>
            Popular openers include <strong>FLUFF</strong> and <strong>VIVID</strong>: they repeat letters and lean on less common letters, which fits both ideas above.
          </p>
          <p>
            Some players open with <strong>QAJAQ</strong>. Opinions vary. Some treat this as fair game, but others feel it’s cheating because the word is so obscure. You can decide for yourself.
          </p>
          <h2>“Wordle first, then Don’t Wordle”</h2>
          <p>
            A straightforward approach is to treat the puzzle like normal Wordle: try to narrow in on the answer without actually submitting it as your guess. Once you have a strong read on what the Wordle word is, use your <strong>Undos</strong> to walk the board back and play out a line that avoids that word while still respecting every clue.
          </p>
          <p>
            This uses undos deliberately rather than only as an emergency—fair game within the rules, but it changes the feel of the challenge if you prefer a purist run.
          </p>
          <h2>You may be trapped</h2>
          <p>
            The counter for <strong>valid words remaining</strong> only tells you how many five-letter words still match every clue so far. It does <em>not</em> guarantee that a winning path still exists.
          </p>
          <p>
            You might be on row 4 with dozens of words left and still have no sequence of legal guesses that reaches the end without typing the Wordle word. The board can look “alive” while you’re already boxed in. When that happens, undos are your only way out.
          </p>

          <h2>"The Purist" approach</h2>
          <p>
            Some players set extra rules to match the spirit of everyday Wordle: use the <strong>Random starting word</strong> button for your first guess and commit to it, and <strong>don’t use any undos</strong>. You live with the board you get, like typing whatever five-letter word comes to mind first in the original game.
          </p>
          <p>
            That also sidesteps leaning on the same optimized openers (like FLUFF or VIVID) every single day. Purists tend to stick to <strong>ordinary, common words</strong>—not obscure dictionary finds such as QAJAQ that are strategically strong but feel removed from how most people play Wordle.
          </p>

          <p>
            <a href="/">Play Don’t Wordle</a>
          </p>
        </div>
      </main>
      <div className="page-footer-slot">
        <Footer />
      </div>
    </div>
  );
}

export default Tips;
